var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "00-Elements-/-Icons-/-x-icon",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7389,4.26108997 C16.1351,4.65727997 16.2101,5.22460998 15.0215,6.41317998 L11.4347,9.99999782 L15.0215,13.5868 C16.2101,14.7754 16.1351,15.3427 15.7389,15.7389 C15.3427,16.1351 14.7754,16.2101 13.5868,15.0215 L9.99999842,11.4347 L6.41317998,15.0215 C5.22461998,16.2101 4.65727997,16.1351 4.26108997,15.7389 C3.86489997,15.3427 3.78988997,14.7754 4.97845997,13.5868 L8.56526999,9.99999782 L4.97845997,6.41318998 C3.78988997,5.22462998 3.86489997,4.65728997 4.26108997,4.26109997 C4.65727997,3.86490997 5.22461998,3.78989997 6.41317998,4.97846997 L9.99999842,8.56527999 L13.5868,4.97844997 C14.7754,3.78988997 15.3427,3.86489997 15.7389,4.26108997 Z",
  id: "x-icon"
}));

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.784f2462.svg";
export { ForwardRef as ReactComponent };